import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

/** Filled in when gift receipts are turned on with no instructions yet. */
export const missingBuyerInfoDescriptionDefault = `Please provide the following information:
 • The item you received and color
 • Original purchaser's:
     a. Full name
     b. Email
     c. Address
 • Your name and address
`;

export const giftReturnsSettingsShape = {
  giftReturns: z.object({
    enabled: z.boolean(),
    instructions: z.string(),
    emailNotifications: z.boolean(),
    notificationEmails: z.array(z.string()),
    requireShopperInfo: z.boolean(),
  }),
};

export type GiftReturnsSettings = z.infer<
  z.ZodObject<typeof giftReturnsSettingsShape>
>;

export function giftReturnsSettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): GiftReturnsSettings {
  const { returns } = settings;
  return {
    giftReturns: {
      // The customer portal treats an unset flag as off.
      enabled: returns?.enableGiftReceipts ?? false,
      instructions: returns?.missingBuyerInfoDescription ?? "",
      emailNotifications:
        returns?.giftReceiptRequestEmailNotificationsEnabled ?? false,
      notificationEmails: returns?.giftReceiptRequestNotificationEmails ?? [],
      requireShopperInfo: returns?.requireGiftReceiptShopperInfo ?? true,
    },
  };
}

export function giftReturnsTeamPatch({
  giftReturns,
}: GiftReturnsSettings): PortalSettingsPatch {
  return {
    set: {
      "returns.enableGiftReceipts": giftReturns.enabled,
      "returns.missingBuyerInfoDescription": giftReturns.instructions,
      "returns.giftReceiptRequestEmailNotificationsEnabled":
        giftReturns.emailNotifications,
      "returns.giftReceiptRequestNotificationEmails":
        giftReturns.notificationEmails,
      "returns.requireGiftReceiptShopperInfo": giftReturns.requireShopperInfo,
    },
    unset: [],
  };
}
